import React from 'react';
import { compressDays, formatTime } from '../../../../utils/format';
import { getLocalDateObject, getLocalDateObjectFromInput } from '../../../../utils/dateTimeZone';
import './GroupAutocompleteOption.scss';

const levelModifiers = new Map([
    ['Nivel 1', 'level1'],
    ['Nivel 2', 'level2'],
    ['Nivel 3', 'level3'],
    ['Nivel 4', 'level4'],
    ['Nivel 5', 'level5'],
    ['Smile 1', 'smile1'],
    ['Smile 2', 'smile2'],
    ['Smile 3', 'smile3'],
    ['Smile 4', 'smile4'],
    ['Smile 5', 'smile5'],
    ['Smile 6', 'smile6'],
    ['Mega', 'mega'],
]);

const GroupAutocompleteOption = ({ id, group }) => {
    const levelModifier = levelModifiers.get(group.level?.name);
    const isOnline = group.is_online === true || group.is_online === 1 || group.is_online === '1';
    const days = compressDays((group.class_day || []).map(day => day.name).filter(Boolean));
    const startDate = group.date?.start ? new Date(group.date.start) : null;
    const isUpcoming = group.is_finished === 0 && group.st === 0 &&
        startDate !== null && !Number.isNaN(startDate.getTime()) && startDate > getLocalDateObject();
    const displayDate = typeof group.date?.start === 'string' && /^\d{4}-\d{2}-\d{2}/.test(group.date.start)
        ? getLocalDateObjectFromInput(group.date.start.slice(0, 10))
        : startDate;
    const upcomingDate = isUpcoming
        ? new Intl.DateTimeFormat('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
            .formatToParts(displayDate)
            .filter(part => ['day', 'month', 'year'].includes(part.type))
            .map(part => part.value.replace('.', '').toUpperCase()).join(' ')
        : '';
    const schedule = group.time?.start && group.time?.end
        ? `${formatTime(group.time.start)} - ${formatTime(group.time.end)}`
        : 'Horario no disponible';

    return (
        <div className={`group-autocomplete-option${isUpcoming ? ' group-autocomplete-option--upcoming' : ''}`}>
            <span className="group-autocomplete-option__id">#{id}</span>
            <div className="group-autocomplete-option__content">
                <div className="group-autocomplete-option__header">
                    <span className="group-autocomplete-option__teacher">{group.teacher?.name || 'Maestro no asignado'}</span>
                    <span className={`group-autocomplete-option__level${levelModifier ? ` group-autocomplete-option__level--${levelModifier}` : ''}`}>{group.level?.name || 'Nivel no especificado'}</span>
                </div>
                {isUpcoming && (
                    <span className="group-autocomplete-option__upcoming">PRÓXIMAMENTE · {upcomingDate}</span>
                )}
                <div className="group-autocomplete-option__details">
                    <span className="group-autocomplete-option__detail">
                        <i className="material-icons" aria-hidden="true">{isOnline ? 'laptop_mac' : 'meeting_room'}</i>
                        {isOnline ? 'Online' : 'Presencial'}
                    </span>
                    <span className="group-autocomplete-option__detail">
                        <i className="material-icons" aria-hidden="true">calendar_today</i>
                        {days || 'Días no especificados'}
                    </span>
                    <span className="group-autocomplete-option__detail">
                        <i className="material-icons" aria-hidden="true">schedule</i>
                        {schedule}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default GroupAutocompleteOption;
